// extracted by mini-css-extract-plugin
module.exports = {"logo":"header_logo-module__logo--MqASl","logoNotLogged":"header_logo-module__logoNotLogged--3BFpS"};